export enum Color {
  RED = "#e2001a",
  BLUE = "#0060A9",
  WHITE = "#FFFFFF",
  GRAY = "#333333",
}
